// @flow
import _ from 'lodash';

import buildEntityActions from 'app/entity/utils/buildEntityActions';
import buildEntityApi from 'app/entity/utils/buildEntityApi';
import buildEntitySelectors from 'app/entity/utils/buildEntitySelectors';
import { remove401StatusFromGetErrorResponse } from 'app/entity/utils/entityUtils';

// Onboarding
export const type = 'onboarding';

export const api = buildEntityApi(
  type,
  '/api/v4/onboardings',
  onboardingAPI => {
    const { loadCollection } = onboardingAPI;

    onboardingAPI.loadCollection = (...args) =>
      loadCollection(...args).catch(
        _.partial(remove401StatusFromGetErrorResponse, type)
      );
  },
  {
    ensureTrailingSlash: true,
  }
);

export const selectors = buildEntitySelectors(type);
export const actions = buildEntityActions(type, selectors, api);
